import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LazyLoadingSpinnerProps {
  message?: string;
}

export const LazyLoadingSpinner: React.FC<LazyLoadingSpinnerProps> = ({ 
  message = "Loading..." 
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      gap={2}
    >
      <CircularProgress size={40} />
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
}; 